import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import Cookies from 'js-cookie'
import Mint, { MessageBox } from 'mint-ui'
import moment from 'moment'
import twMomentMessages from './lang/moment/tw'
import i18n from './i18n'
import LoadScript from 'vue-plugin-load-script'
import utils from './util/util'
import * as VueGoogleMaps from 'vue2-google-maps'
import Cube, { Locale } from 'cube-ui'
import zhTWMessages from './lang/cube-ui/zh-TW'
import VueCardFormat from 'vue-credit-card-validation';
import Vuelidate from 'vuelidate'
import vuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import VueClipboard from 'vue-clipboard2'
import 'es6-promise/auto'
import 'mint-ui/lib/style.css'
import './assets/style/iconfont/iconfont.css'
import './assets/style/common.scss'
import './assets/style/my-mint.scss'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import url from './util/url'
import './util/bugsnag'
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'

import { Alert } from '@src/util/alert'
import vmodal from 'vue-js-modal'

// 樣式框架
Vue.use(VueCardFormat)
Vue.use(Cube)
Vue.use(Locale)
Vue.use(Mint)
Vue.use(vmodal)
Vue.use(VueClipboard)
// 資料驗證
Vue.use(vuelidateErrorExtractor, {
  template: templates.singleErrorExtractor.foundation6,
  messages: i18n.getLocaleMessage(process.env.VUE_APP_I18N_LOCALE).validation
})
Vue.use(Vuelidate)
Vue.use(Loading)
Vue.use(LoadScript)
Vue.prototype.utils = utils
Vue.prototype.$cookie = Cookies
Vue.prototype.$alert = Alert

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places,geometry'
  },
  autobindAllEvents: true,
  installComponents: true
})
Vue.$gmapApiPromiseLazy().then((google) => {
  Vue.prototype.$google = google
})

let clientType
let token

if (location.pathname === '/' || url.is('^/member/') || url.is('^/home/')) {
  clientType = 'member'
  token = store.state.member.token
} else if (url.is('^/distributor/')) {
  clientType = 'distributor'
  token = store.state.distributor.token
}

Vue.use(new VueSocketIO({
  debug: process.env.NODE_ENV === 'development',
  connection: SocketIO(process.env.VUE_APP_SOCKET_HOST, {
    autoConnect: false,
    extraHeaders: {
      'authorization': token,
      'client_type': clientType
    }
  })
}))

moment.locale(process.env.VUE_APP_I18N_LOCALE, twMomentMessages)

Locale.use(process.env.VUE_APP_I18N_LOCALE, zhTWMessages)

Vue.prototype.utils = utils
Vue.prototype.$cookie = Cookies
Vue.prototype.$moment = moment

MessageBox.setDefaults({
  confirmButtonText: i18n.getLocaleMessage(process.env.VUE_APP_I18N_LOCALE).general.enter
})

Vue.config.productionTip = false

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
// new Vue({
//     el: '#app',
//     store,
//     router,
//     components: { App },
//     template: '<App/>'
// })
